import { useEffect } from "react";

export default function ThreeD() {

  useEffect(() => {
    // Small delay to ensure React has fully rendered DOM
    const timer = setTimeout(init, 200);
    return () => clearTimeout(timer);
  }, []);

  return null;
}

function init() {
  applyTilt();
  applyNavScroll();
  applyHeroCursor();
  applyButtonPress();
}

/* ── Mouse-tracking 3D tilt on cards ── */
function applyTilt() {
  const SELECTORS = ".premium-card, .service-card, .process-point, .job-card, .profile-card, .intro-shell";
  const els = document.querySelectorAll(SELECTORS);
  const MAX = 10, SCALE = 1.035, P = 900;

  els.forEach((el) => {
    if (el.dataset.tilt) return; // skip if already applied
    el.dataset.tilt = "1";
    el.style.transformStyle = "preserve-3d";
    el.style.willChange = "transform";
    if (getComputedStyle(el).position === "static") el.style.position = "relative";

    // glare layer
    const glare = document.createElement("div");
    glare.className = "tilt-glare";
    glare.style.cssText =
      "position:absolute;inset:0;border-radius:inherit;opacity:0;" +
      "background:radial-gradient(circle at 50% 50%,rgba(255,255,255,0.22) 0%,transparent 58%);" +
      "pointer-events:none;z-index:9;transition:opacity 0.3s ease;";
    el.appendChild(glare);

    el.addEventListener("mousemove", (e) => {
      const r = el.getBoundingClientRect();
      const rx = -(((e.clientY - r.top)  / r.height) - 0.5) * MAX * 2;
      const ry =  (((e.clientX - r.left) / r.width)  - 0.5) * MAX * 2;
      el.style.transform = `perspective(${P}px) rotateX(${rx}deg) rotateY(${ry}deg) scale(${SCALE})`;
      el.style.boxShadow = `${-ry*2}px ${rx*2}px 44px rgba(255,122,0,0.22),0 22px 50px rgba(15,23,42,0.11)`;
      const gx = ((e.clientX - r.left) / r.width)  * 100;
      const gy = ((e.clientY - r.top)  / r.height) * 100;
      glare.style.background = `radial-gradient(circle at ${gx}% ${gy}%, rgba(255,255,255,0.26) 0%, transparent 58%)`;
      glare.style.opacity = "1";
    });

    el.addEventListener("mouseleave", () => {
      el.style.transform = `perspective(${P}px) rotateX(0deg) rotateY(0deg) scale(1)`;
      el.style.boxShadow = "";
      glare.style.opacity = "0";
    });
  });
}

/* ── Navbar depth shadow on scroll ── */
function applyNavScroll() {
  const nav = document.querySelector(
    ".navbar, .services-navbar, .who-navbar, .careers-navbar, .team-navbar"
  );
  if (!nav) return;
  const onScroll = () => nav.classList.toggle("scrolled", window.scrollY > 30);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

/* ── Hero section cursor parallax tilt ── */
function applyHeroCursor() {
  const hero = document.querySelector(".poster-carousel, .services-hero");
  if (!hero) return;
  hero.style.transformStyle = "preserve-3d";

  hero.addEventListener("mousemove", (e) => {
    const r = hero.getBoundingClientRect();
    const rx = -(((e.clientY - r.top)  / r.height) - 0.5) * 5;
    const ry =  (((e.clientX - r.left) / r.width)  - 0.5) * 5;
    hero.style.transform = `perspective(1400px) rotateX(${rx}deg) rotateY(${ry}deg)`;
    hero.style.transition = "transform 0.06s ease";
  });

  hero.addEventListener("mouseleave", () => {
    hero.style.transform = "perspective(1400px) rotateX(0deg) rotateY(0deg)";
    hero.style.transition = "transform 0.7s ease";
  });
}

/* ── Button press depth ── */
function applyButtonPress() {
  const btns = document.querySelectorAll(
    ".poster-btn, .hero-btn, .apply-btn, .back-button, .contact-box button, .apply-form button"
  );
  btns.forEach((btn) => {
    if (btn.dataset.press) return;
    btn.dataset.press = "1";
    btn.addEventListener("mousedown", () => {
      btn.style.transform = "perspective(400px) translateZ(-6px) scale(0.955)";
      btn.style.boxShadow = "0 3px 10px rgba(255,122,0,0.18)";
      btn.style.transition = "transform 0.08s ease, box-shadow 0.08s ease";
    });
    const up = () => {
      btn.style.transform = "";
      btn.style.boxShadow = "";
      btn.style.transition = "transform 0.25s ease, box-shadow 0.25s ease";
    };
    btn.addEventListener("mouseup", up);
    btn.addEventListener("mouseleave", up);
  });
}
